// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nv-1";
export var stateContainer = "_nv-0";